import DeliveryOption from '@/controllers/options/DeliveryOption';
import DeliveryOptionConstants from '@/controllers/options/DeliveryOptionConstants';
import DeliveryOptionsProvider from '@/models/DeliveryOptionsProvider';
import IOptionHandler from './IOptionHandler';

class DisplayTitleOptionHandler implements IOptionHandler {
  execute(provider: DeliveryOptionsProvider, map: Map<string, unknown>): void {
    const showFormTitle: boolean = map.get(DeliveryOptionConstants.SHOW_FORM_TITLE) as boolean;
    const displayTitle: string = map.get(DeliveryOptionConstants.DISPLAY_TITLE) as string;
    const displaySubtitle: string = map.get(DeliveryOptionConstants.DISPLAY_SUBTITLE) as string;

    if (showFormTitle) {
      const titleDeliveryOption: DeliveryOption = new DeliveryOption(DeliveryOptionConstants.SHOW_FORM_TITLE);
      if (this.valuePresent(displayTitle)) {
        titleDeliveryOption.addSetting('title', displayTitle);
      }

      if (this.valuePresent(displaySubtitle)) {
        titleDeliveryOption.addSetting('subtitle', displaySubtitle);
      }

      provider.addDeliveryOption(titleDeliveryOption);
    }
  }

  private valuePresent(value: string | undefined): boolean {
    return value !== undefined && value.trim().length > 0;
  }
}

export default DisplayTitleOptionHandler;
